<script setup>
import { computed } from "vue";
import { RouterLink } from "vue-router";

const props = defineProps({
    // add @ts-ignore if using TypeScript
    ...RouterLink.props,
    inactiveClass: String,
    current: {
        type: Boolean,
        default: false,
    },
});

const isExternalLink = computed(() => {
    return typeof props.to === "string" && (props.to.startsWith("http") || props.to.startsWith("mailto"));
});
</script>

<template>
    <a v-if="isExternalLink" v-bind="$attrs" :href="to" :class="inactiveClass">
        <slot />
    </a>
    <RouterLink v-else v-bind="$props" custom v-slot="{ isActive, href, navigate }">
        <a v-bind="$attrs" :href="href" @click="navigate" :class="current ? activeClass : inactiveClass" :aria-current="current ? 'page' : undefined">
            <slot v-bind="{ isActive: current, href, navigate }" />
        </a>
    </RouterLink>
</template>
